
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 462.78 539.42","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M433.97 184.52L317.16 67.71c-14.93-14.93-38.12-16.05-51.69-2.49l-238 238c-13.56 13.56-12.44 36.75 2.49 51.69l116.8 116.8c14.94 14.94 38.13 16.06 51.69 2.49l238-238c13.57-13.56 12.45-36.75-2.48-51.68zM187.14 462.89c-7.33 7.32-20.36 6.2-29.06-2.5L41.27 343.59c-8.69-8.69-9.81-21.73-2.48-29.06l5.4-5.4 148.35 148.36-5.4 5.4zm119-119L203.86 446.17 55.51 297.82l102.28-102.29L260.07 93.25l148.36 148.36-102.29 102.28zm119-119l-5.4 5.4L271.38 81.94l5.41-5.41c7.32-7.32 20.36-6.2 29.06 2.5l116.8 116.8c8.7 8.7 9.82 21.73 2.49 29.06z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M321.15 196.3h16v94.87h-16zM355.86 222.81h16v29.25h-16zM250.38 50.43l-50.42 50.42-11.32-11.32 32.75-32.74c-55.26-2.83-108.48 17.49-148.07 57.08-41.84 41.84-62.35 99.63-56.26 158.56l-15.92 1.64c-6.58-63.74 15.6-126.25 60.87-171.51C85.76 78.8 113.89 61.49 145.6 51.1c23.22-7.61 47.89-11.14 72.41-10.41l-29.37-29.37L199.96 0l50.42 50.43zM401.92 436.86c-23.76 23.76-51.88 41.07-83.59 51.46-23.22 7.61-47.9 11.14-72.42 10.41l29.37 29.37-11.31 11.32L213.55 489l50.42-50.42 11.31 11.31-32.73 32.74c55.26 2.84 108.47-17.49 148.06-57.08 41.84-41.84 62.34-99.63 56.26-158.56l15.91-1.64c6.59 63.74-15.6 126.25-60.86 171.51z"}})])
          )
        }
      }
    